import '@fortawesome/fontawesome-svg-core/styles.css';
import App from 'app';
import Keycloak from 'keycloak-js';
import React, { Suspense } from 'react';
import { Provider } from 'react-redux';

// Styles
import { updateHeader } from './api';
import { ApplicationLoader } from './app/shared/component/loader/application-loader';
import store from './app/store';
import './i18n';
import * as serviceWorker from './serviceWorker';
import './theme/index.scss';
import { createRoot } from 'react-dom/client';
import _ from 'lodash';

const authorizedRoles: Array<string> = ['publicUser'];

const app = (
  <Suspense fallback={<ApplicationLoader />}>
    <Provider store={store}>
      <App />
    </Provider>
  </Suspense>
);

export const KC: Keycloak = new Keycloak({
  url: `${process.env.REACT_APP_KEYCLOAK_URL}/auth`,
  realm: 'DCC_PUBLIC',
  clientId: 'maf_portal_security',
});

KC.init({ onLoad: 'login-required', checkLoginIframe: false }).then((authenticated: boolean) => {
  if (authenticated) {
    // check roles workaround until permissions are added
    if (_.get(KC, 'tokenParsed.resource_access.maf_portal_security.roles', []).some((role: string) => authorizedRoles.includes(role))) {
      store.dispatch({ type: 'GET_USER', payload: KC });

      setInterval(() => {
        KC.updateToken(10)
          .then(() => {
            updateHeader(KC.token ? KC.token : '');
          })
          .catch(() => KC.login());
      }, 10000);

      updateHeader(KC.token ? KC.token : '');

      const container = document.getElementById('root');
      const root = createRoot(container!);
      root.render(app);
    } else {
      KC.logout();
    }
  } else {
    // show possibly other page here...
    KC.login();
  }
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
